import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Megaphone } from "lucide-react";
import { useSite } from "@/context/SiteSettings";

const DISMISS_KEY = "avm_announcement_dismissed";

export const AnnouncementBar = () => {
    const { announcement } = useSite();
    const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === "1");

    const visible = Boolean(announcement?.enabled && announcement?.text?.trim()) && !dismissed;

    useEffect(() => {
        document.documentElement.style.setProperty("--bar-h", visible ? "40px" : "0px");
    }, [visible]);

    if (!visible) return null;

    const { text, link_url: url, link_label: label } = announcement;
    const isInternal = url?.startsWith("/");

    return (
        <div
            data-testid="announcement-bar"
            className="fixed top-0 inset-x-0 z-[60] h-10 bg-gradient-to-r from-amber-600 via-amber-500 to-amber-600 text-black"
        >
            <div className="max-w-7xl mx-auto h-full px-5 sm:px-8 flex items-center justify-center gap-3">
                <Megaphone size={14} className="shrink-0" />
                <p className="font-meta text-[10px] sm:text-[11px] tracking-[0.15em] uppercase font-bold truncate">
                    {text}
                </p>
                {url && label &&
                    (isInternal ? (
                        <Link
                            to={url}
                            data-testid="announcement-bar-link"
                            className="shrink-0 font-meta text-[10px] tracking-[0.15em] uppercase underline underline-offset-2 hover:no-underline"
                        >
                            {label}
                        </Link>
                    ) : (
                        <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="announcement-bar-link"
                            className="shrink-0 font-meta text-[10px] tracking-[0.15em] uppercase underline underline-offset-2 hover:no-underline"
                        >
                            {label}
                        </a>
                    ))}
                <button
                    onClick={() => {
                        sessionStorage.setItem(DISMISS_KEY, "1");
                        setDismissed(true);
                    }}
                    aria-label="Dismiss announcement"
                    data-testid="announcement-bar-dismiss"
                    className="absolute right-4 w-7 h-7 rounded-full flex items-center justify-center hover:bg-black/15 transition-colors duration-200"
                >
                    <X size={14} />
                </button>
            </div>
        </div>
    );
};

export default AnnouncementBar;
